import { ITextContentState } from '../types'

export const SET_INITIAL_TEXT_CONTENTS = "SET_INITIAL_TEXT_CONTENTS"

export interface SetInitialTextContentAction {
   type: typeof SET_INITIAL_TEXT_CONTENTS;
   payload: ITextContentState;
}

export type TextContentsActions = 
SetInitialTextContentAction 

